module.exports = __webpack_public_path__ + "img/2-6.d862fb7.svg";